//Lightbox für Zoom
$(document).ready(function(){
    var overlayOn = function()
        {
            $( '<div id="imagelightbox-overlay"></div>' ).appendTo( 'body' );
        },
        overlayOff = function()
        {
            $( '#imagelightbox-overlay' ).remove();
        },
        closeButtonOn = function( instance )
        {
            $( '<a href="#" class="lightboxbtn" id="imagelightbox-close"><i class="fa fa-close"></i></a>' ).appendTo( 'body' ).on( 'click', function(){ 
                $( this ).remove(); 
                instance.quitImageLightbox(); 
                return false; });
        },
        closeButtonOff = function()
        {
            $( '#imagelightbox-close' ).remove();
        };
        // ARROWS

        arrowsOn = function( instance, selector )
        {
            var $arrows = $( '<button type="button" class="lightboxbtn imagelightbox-arrow imagelightbox-arrow-left"><i class="fa fa-angle-left"></i></button><button type="button" class="lightboxbtn imagelightbox-arrow imagelightbox-arrow-right"><i class="fa fa-angle-right"></i></button>' );

            $arrows.appendTo( 'body' );

            $arrows.on( 'click touchend', function( e )
            {
                e.preventDefault();

                var $this   = $( this ),
                    $target = $( selector + '[href="' + $( '#imagelightbox' ).attr( 'src' ) + '"]' ),
                    index   = $target.index( selector );

                if( $this.hasClass( 'imagelightbox-arrow-left' ) )
                {
                    index = index - 1;
                    if( !$( selector ).eq( index ).length )
                        index = $( selector ).length;
                }
                else
                {
                    index = index + 1;
                    if( !$( selector ).eq( index ).length )
                        index = 0;
                }

                instance.switchImageLightbox( index );
                return false;
            });
        },
        arrowsOff = function()
        {
            $( '.imagelightbox-arrow' ).remove();
        },
        zoomButtonInit = function(instance, selector)
        {
            var $buttons = $( '<button type="button" id="zoomInButton" class="lightboxbtn imagelightbox-zoom imagelightbox-zoomin"><i class="fa fa-plus"></i></button><button id="zoomOutButton" type="button" class="lightboxbtn imagelightbox-zoom imagelightbox-zoomout"><i class="fa fa-minus"></i></button>' );
            $buttons.appendTo( 'body' );
        },
        zoomButtonOn = function()
        {
            $('body').find('#imagelightbox').animate({'opacity': '1'}, 'slow');
            $('#imagelightbox').smartZoom({'containerClass':'zoomableContainer'});
                
            $('#zoomInButton').click(zoomin);
            $('#zoomOutButton').click(zoomout);
            function zoomin(e){
                var scaleToAdd = 0.8;
                $('#imagelightbox').smartZoom('zoom', scaleToAdd);
            }
            function zoomout(e){
                var scaleToAdd = 0.8;
                scaleToAdd = -scaleToAdd;
                $('#imagelightbox').smartZoom('zoom', scaleToAdd);
            }
        },
        zoomButtonOff = function()
        {
            $('body').removeClass('ovh');
            $('.zoom-wrapper').css( 'display', 'none' );
            $('.imagelightbox-zoom').remove()
        }
        navigationOn = function( instance, selector )
        {
            var images = $( selector );
            if( images.length )
            {
                var nav = $( '<div id="imagelightbox-nav"></div>' );
                for( var i = 0; i < images.length; i++ )
                    nav.append( '<button type="button"></button>' );

                nav.appendTo( 'body' );
                nav.on( 'click touchend', function(){ return false; });

                var navItems = nav.find( 'button' );
                navItems.on( 'click touchend', function()
                {
                    var $this = $( this );
                    if( images.eq( $this.index() ).attr( 'href' ) != $( '#imagelightbox' ).attr( 'src' ) )
                        instance.switchImageLightbox( $this.index() );

                    navItems.removeClass( 'active' );
                    navItems.eq( $this.index() ).addClass( 'active' );

                    return false;
                })
                .on( 'touchend', function(){ return false; });
            }
        },
        navigationUpdate = function( selector )
        {
            var items = $( '#imagelightbox-nav button' );
            items.removeClass( 'active' );
            items.eq( $( selector ).filter( '[href="' + $( '#imagelightbox' ).attr( 'src' ) + '"]' ).index( selector ) ).addClass( 'active' );
        },
        navigationOff = function()
        {
            $( '#imagelightbox-nav' ).remove();
        };

    var selector = 'a[data-imagelightbox="lightbox"]';
    var instance = $( selector ).imageLightbox({
        animationSpeed: 250,                    // integer;
        preloadNext:    true,                   // bool;            silently preload the next image
        enableKeyboard: true,                   // bool;            enable keyboard shortcuts (arrows Left/Right and Esc)
        quitOnEnd:      false,                  // bool;            quit after viewing the last image
        quitOnImgClick: false,                  // bool;            quit when the viewed image is clicked
        quitOnDocClick: false,                   // bool;            quit when anything but the viewed image is clicked
        onStart:     function() { navigationOn( instance, selector ); overlayOn(); closeButtonOn(instance); zoomButtonInit(); arrowsOn(instance, selector); },
        onEnd:       function() { navigationOff(); overlayOff(); closeButtonOff(); zoomButtonOff(); arrowsOff(); },
        onLoadStart: function(){
            
        },              // function/bool;   calls function when the image load begins
        onLoadEnd:   function(){
            $('body').addClass('ovh');
            $('.zoomableContainer').remove();
            $('.zoom-wrapper').css( 'display', 'block' );
            zoomButtonOn(); 
            navigationUpdate( selector );
            $( '.imagelightbox-arrow' ).css( 'display', 'block' );
        }// function/bool;   calls function when the image finishes loading
    });
});
//END